export default __webpack_public_path__ + "static/media/logo-boldare-products.0a4db40d.svg";